<template>
    <div class="row content-wrapper security-popup">
        <div class="security-popup__content">
            <img
                class="security-popup__image"
                src="@/assets/upload-instructions/shield.png"
                alt=""
            />
            <h3>{{ $t(`${TRANSLATION_KEY}.dataSecurityHeader`) }}</h3>
            <p>{{ $t(`${TRANSLATION_KEY}.dataSecurityText`) }}</p>
        </div>
        <div
            class="row row--navigation-btn d-flex justify-center security-button"
        >
            <span
                class="button button-biger button--submit security-button"
                @click="handleClosePopup"
            >
                {{ $t(`${TRANSLATION_KEY}.close`) }}
            </span>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { Locale } from '@/constants/locale';
import { useStore } from 'vuex';

export default defineComponent({
    name: 'SecurityPopup',
    setup() {
        const store = useStore();

        const TRANSLATION_KEY = 'steps.SecurityPopup';
        const showSecurityPopup = computed(() => store.state.showSecurityPopup);

        const handleClosePopup = () => {
            store.state.showSecurityPopup = false;
        };

        return {
            Locale,
            TRANSLATION_KEY,
            handleClosePopup,
            showSecurityPopup,
        };
    },
});
</script>

<style lang="scss" scoped>
.security-popup {
    position: fixed;
    width: 100%;
    z-index: 11;
    height: 100vh;
    background: #022247;
    padding: 20px;
    display: flex;
    flex-direction: column;
    &__content {
        text-align: center;
        margin-top: auto;
        margin-bottom: auto;
        h3,
        p {
            color: #fff;
        }
        h3 {
            margin-bottom: 12px;
            font-size: 24px;
            font-weight: 400;
            font-family: 'sofia-pro', sans-serif;
        }

        p {
            font-size: 16px;
            line-height: 1.5;
        }
    }
    &__image {
        width: 63px;
        height: 67px;
        margin-bottom: 12px;
    }
    .button {
        margin-top: 0;
    }

    .button--submit {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff !important;
        color: #022247;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        letter-spacing: 0.32px;
        &:hover {
            opacity: 0.8;
        }
    }

    .security-button {
        margin-top: auto;
        margin-bottom: 80px;
    }
}
</style>
